module.exports = __webpack_public_path__ + "img/ring_y_i_0_0.634875de.png";